import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export default function Footer() {
    const { t } = useTranslation();
    const year = new Date().getFullYear();
    return (
        <footer className="bg-[#0a0a0c] border-t border-white/5 px-6 md:px-10 py-10 mt-20" data-testid="site-footer">
            <div className="max-w-7xl mx-auto grid sm:grid-cols-3 gap-8">
                <div>
                    <div className="flex items-center gap-2">
                        <div className="h-px w-8 bg-gold" />
                        <span className="text-gold text-[10px] tracking-[0.4em] uppercase">Prenova by Renova360</span>
                    </div>
                    <p className="text-gray-500 text-xs mt-3 leading-relaxed" data-testid="footer-tagline">
                        {t("footer.tagline")}
                    </p>
                </div>

                <div>
                    <div className="text-[10px] uppercase tracking-[0.3em] text-gray-400 mb-3">{t("footer.for_restaurateurs")}</div>
                    <ul className="space-y-1.5 text-xs text-gray-300">
                        <li><Link to="/iscrizione-ristoratore" className="hover:text-gold transition-colors" data-testid="footer-signup-restaurateur">{t("footer.signup_link")}</Link></li>
                        <li><Link to="/admin/login" className="hover:text-gold transition-colors">{t("footer.admin_area")}</Link></li>
                    </ul>
                </div>

                <div>
                    <div className="text-[10px] uppercase tracking-[0.3em] text-gray-400 mb-3">{t("footer.legal")}</div>
                    <ul className="space-y-1.5 text-xs text-gray-300">
                        <li><Link to="/privacy" className="hover:text-gold transition-colors" data-testid="footer-privacy">{t("footer.privacy_policy")}</Link></li>
                        <li><Link to="/cookie-policy" className="hover:text-gold transition-colors" data-testid="footer-cookies">{t("footer.cookie_policy")}</Link></li>
                    </ul>
                </div>
            </div>

            <div className="max-w-7xl mx-auto mt-8 pt-6 border-t border-white/5 flex flex-col sm:flex-row justify-between gap-2 text-[11px] text-gray-600">
                <div>© {year} <strong className="text-gray-500">MAKAI di Maria Laura Pellino</strong> · P.IVA 09936410969 · {t("footer.rights_reserved")}</div>
                <div>{t("footer.payments_line")}</div>
            </div>
        </footer>
    );
}
